import * as ms from 'milliseconds';

export const GRID_UNIT = 8;

// The screen width at which the rail is automatically collapsed
export const RAIL_LARGE_SCREEN_THRESHOLD = 1126;

// Expanded left rail width (mirrors --rail-width in vars.css)
export const RAIL_WIDTH = 320;
// Minimum comfortable chat pane width in split views
export const MIN_CHAT_WIDTH = 385;
// Minimum card column width in split views (mirrors --narrow-width floor / 48Q)
export const CARD_COLUMN_MIN_WIDTH = 384;
// Below this viewport width an expanded rail would squish chat below MIN_CHAT_WIDTH
// in split views, so the rail is force-collapsed (and hover-expands as an overlay).
export const RAIL_AUTO_COLLAPSE_THRESHOLD = RAIL_WIDTH + MIN_CHAT_WIDTH + CARD_COLUMN_MIN_WIDTH;

// Business logic and app constants (same across all environments)
export const NUM_CHAT_MESSAGES_TO_FETCH = 25;
export const PRICING_LIMIT_HISTORY_DAYS = 7;

export const FONT_STACK =
  '-apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

export const HEADER_HEIGHT = 64;

export const TOAST_DEFAULT_DURATION = ms.seconds(10);
export const IS_TYPING_TIMEOUT_DURATION = ms.seconds(5);
export const IS_TYPING_UPDATE_THROTTLE_DURATION = ms.seconds(2);
export const MESSAGE_GROUPING_TIME_SPAN = ms.minutes(1);
export const SEARCH_RESULT_NUM_CHARS_BEFORE_MATCH_TO_SHOW = 40;

export const DISMOUNT_VIEW_DELAY = ms.seconds(1);
export const MARK_CARDS_VIEWED_DELAY = ms.seconds(2); // must be greater than DISMOUNT_VIEW_DELAY
export const MARK_MESSAGES_AS_READ_DELAY = ms.seconds(2); // must be greater than DISMOUNT_VIEW_DELAY

export const RELATED_LOOKUP_NAME_SEPARATOR = '→';

// Size of the channel image shown in the channel create/edit form.
export const SELECTED_CHANNEL_IMAGE_SIZE = 10 * GRID_UNIT;
